import { useEffect } from 'react';

import Bouncer from 'approot/shared/bouncer/bouncer';
import {
  DownloadingModalBouncerStyled,
  DownloadingModalContainerStyled,
  DownloadingModalHeaderStyled,
  DownloadingModalTextStyled,
} from './downloading-modal.style';
import { useDownloadingModalState } from '../modal/modal.hooks';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import SimpleModal from 'lib/modal/simple-modal';

type Props = {
  title: string;
  text: string;
  isLoading: boolean;
  hasError?: boolean;
  errorMessage?: string;
};

export const DownloadingModal = ({
  title,
  text,
  isLoading,
  hasError,
  errorMessage,
}: Props) => {
  const { isVisible } = useDownloadingModalState(isLoading);

  const { showError } = useSnackbar();

  // show error message upon closing the modal
  useEffect(() => {
    if (!isVisible && hasError && errorMessage) {
      showError(errorMessage);
    }
    // eslint-disable-next-line
  }, [isVisible, hasError]);

  return (
    <SimpleModal
      size={456}
      isVisible={isVisible}
      title={title}
      isCloseButtonVisible={false}
      removeHeaderHeight
    >
      <DownloadingModalContainerStyled>
        <DownloadingModalHeaderStyled>{title}</DownloadingModalHeaderStyled>
        <DownloadingModalTextStyled>{text}</DownloadingModalTextStyled>
        <DownloadingModalBouncerStyled>
          <Bouncer />
        </DownloadingModalBouncerStyled>
      </DownloadingModalContainerStyled>
    </SimpleModal>
  );
};
